/* Packages */
import React from 'react';
import {render} from 'react-dom';

/* Helpers */
import {parseDataToProps} from '../helpers';

const locationOverviewNodes = document.querySelectorAll('.establishment-search');

if (locationOverviewNodes.length > 0) {
    import(/* webpackChunkName: "EstablishmentSearch" */ './components/EstablishmentSearch').then(({default: EstablishmentSearch}) => {
        [...locationOverviewNodes].forEach((node) => render(
            <EstablishmentSearch {...parseDataToProps(node.dataset)} />, node));
    });
}
